module.exports = __webpack_public_path__ + "img/Icon - Error.419ef155.svg";